import { render } from "./FinancePage.vue?vue&type=template&id=27e9cba8&ts=true"
import script from "./FinancePage.vue?vue&type=script&lang=ts"
export * from "./FinancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__